import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const NotAttended = () => {
    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default NotAttended;